import React from 'react';

import { ExploitsIcon } from 'pages/Landings/components/Icons';
import Paragraph from 'pages/Landings/components/Paragraph';
import TopicContent from 'pages/Landings/components/TopicContent';
import TopicHeading from 'pages/Landings/components/TopicHeading';
import TopicTemplate from 'pages/Landings/components/TopicTemplate';

const Exploits: React.FC = () => {
    return (
        <TopicTemplate
            heading={
                <TopicHeading
                    title="Exploits"
                    description="Track fresh PoCs and wild exploitation listings as they appear. Instantly see if they can affect your assets and what needs to be prioritized for remediation."
                    illustration={<ExploitsIcon />}
                />
            }
            content={
                <TopicContent link="https://docs.vulners.com/docs/products/exploits/">
                    <Paragraph
                        primary="From Theoretical to Real — Fast"
                        secondary="Know the moment “theoretical” turns real. Vulners links PoCs, tool releases, and KEV items to their CVEs so your backlog reorders itself by active threat, not just severity. “Exploitation in Progress” indicators and exploit timelines keep hot vulnerabilities front and center across your assets."
                    />
                    <Paragraph
                        primary="Connect Signal to Impact"
                        secondary="Tie signal to impact automatically. Cross-reference Exploits with Assessment to auto-flag “exploited + present here” for immediate escalation. Incident response and detection teams can focus monitoring and containment where attackers are actually aiming, so you fix what’s dangerous now—not just what’s rated high."
                    />
                </TopicContent>
            }
        />
    );
};

export default Exploits;
